import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Cataloghi } from 'my-lib-sanfelici';
import { CataloghiService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-cataloghi-details',
  templateUrl: './cataloghi-details.component.html',
  styleUrls: ['./cataloghi-details.component.css']
})
export class CataloghiDetailsComponent implements OnInit {

catalogo: Observable<Cataloghi>;
    constructor(
        private route: ActivatedRoute,
        private cataloghiservice: CataloghiService
    ) { }

  ngOnInit() {
      const id = this.route.snapshot.params['id'];
      this.catalogo = this.cataloghiservice.get(id);
  }

}
